$(window).load(function() {
  var lastScrollTop = 0;
  var hasScrolledDown = false;
  var isFixed = true;

  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod|Macintosh/.test(ua) && !window.MSStream) {
    document.body.classList.add('ios');
  }

  function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  function checkScrollPosition() {
    var scrollTop = $('#CartPopup').scrollTop();
    ////console.log('isFixed init: ' + isFixed);
    if (scrollTop >= lastScrollTop) {
      // Scrolling down
      //console.log('********');
      //console.log(isFixed);
      //console.log('********');
      if (scrollTop > 50 && isFixed === true) {
        //console.log('If: '+ isFixed);
        $('.upcart-footer').removeClass('fixed');
        $('.upcart-upsells-module').removeClass('fixed');
        isFixed = false;
      }
    } else {
      // Scrolling up
      if (isFixed === false) {
        //console.log('Else: '+ isFixed);
        $('.upcart-footer').addClass('fixed');
        $('.upcart-upsells-module').addClass('fixed');
        isFixed = true;
      }
    }
    lastScrollTop = scrollTop;
  }

  window.upcartOnCartClosed = function (cart) {
    setTimeout(function() {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
          if (cart.item_count === 0) {
            $('#cart-icon-bubble').html('<svg class="icon icon-cart" aria-hidden="true" focusable="false" width="22" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 33" fill="none"><path d="M10 29.5C11.1046 29.5 12 28.6046 12 27.5C12 26.3954 11.1046 25.5 10 25.5C8.89543 25.5 8 26.3954 8 27.5C8 28.6046 8.89543 29.5 10 29.5Z" fill="#270739"></path><path d="M23 29.5C24.1046 29.5 25 28.6046 25 27.5C25 26.3954 24.1046 25.5 23 25.5C21.8954 25.5 21 26.3954 21 27.5C21 28.6046 21.8954 29.5 23 29.5Z" fill="#270739"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M3.09962 3.5C3.53426 3.49969 3.95719 3.64098 4.30437 3.90249C4.65174 4.16414 4.90435 4.53189 5.02394 4.95L6.03903 8.5H27.7125C28.0263 8.5 28.3219 8.64729 28.5108 8.8978C28.6998 9.14832 28.7602 9.473 28.674 9.77472L25.3752 21.3204C25.3751 21.3211 25.3749 21.3218 25.3747 21.3224C25.1974 21.9517 24.8187 22.5055 24.2965 22.8988C23.7746 23.2919 23.1383 23.5031 22.4849 23.5C22.4839 23.5 22.4828 23.5 22.4817 23.5L22.4875 22.5V23.5H22.4849H10.5151C10.5161 23.5 10.5172 23.5 10.5183 23.5L10.5125 22.5V23.5H10.5151C9.86174 23.5031 9.22539 23.2919 8.7035 22.8988C8.18143 22.5056 7.80274 21.952 7.62546 21.3229L7.62603 21.3249L8.5875 21.05L7.62476 21.3204L3.10106 5.5L1 5.5C0.447715 5.5 0 5.05229 0 4.5C0 3.94772 0.447715 3.5 1 3.5H3.09962ZM3.09962 3.5C3.09939 3.5 3.09984 3.5 3.09962 3.5V3.5ZM6.61091 10.5L9.55025 20.7796C9.60874 20.9878 9.73402 21.1711 9.90681 21.3013C10.0796 21.4315 10.2904 21.5013 10.5067 21.5L10.5125 21.5L22.4933 21.5C22.7096 21.5013 22.9204 21.4315 23.0932 21.3013C23.266 21.1711 23.3913 20.9878 23.4498 20.7796L23.451 20.7753L26.3868 10.5H6.61091Z" fill="#270739"></path></svg>');
          } 
        },
        error: function(XMLHttpRequest, textStatus) {
          //console.log("Error occurred while checking the cart.");
        }
      });
      $('#CartPopup').scrollTop(0);
      $('.upcart-footer').removeClass('fixed');
      $('.upcart-upsells-module').removeClass('fixed');
      isFixed = true;
    }, 100);
  }

  window.upcartOnCartOpened = function (cart) {
    setTimeout(function() {
      var scrollHeight = $('#CartPopup').prop('scrollHeight');
      var height = $('#CartPopup').height() - 1;

      if (scrollHeight > height) {
        $('.upcart-footer').addClass('fixed');
        $('.upcart-upsells-module').addClass('fixed');
      } else {
        //console.log('#CartPopUp can not scroll.');
      }
      isFixed = true;
    }, 1000);
  }

  window.upcartOnCartUpdated = function (cart) {
    setTimeout(function() {
      if ($('body').attr('data-upcart-cart-enabled') === 'true') {
        checkScrollPosition(); 
      }
    }, 400);
  }

  var lastScrollTop = 0;
  
  // Handle Scroll in CartDrawer
  function handleScroll(event) {
    if (!isMobileDevice()) {
      checkScrollPosition();
    }
  }

  // Detect scroll on #CartPopup
  $('#CartPopup').on('scroll', handleScroll);

   var isScrolling;
   var checkTwice = null;

  // Touch events in mobile devices
  $('#CartPopup').on('touchend', function(event) {
    if (isMobileDevice()) {
      if (/iPad|iPhone|iPod|Macintosh/.test(ua) && !window.MSStream) {
        setTimeout(function() {
          checkTwice = isFixed;
          //console.log('First\nBefore: ' + checkTwice + ' : ' + isFixed);
          checkScrollPosition();
          //console.log('After: ' + checkTwice + ' : ' + isFixed + '\n\n');
        }, 600);
      } else {
        setTimeout(function() {
          checkTwice = isFixed;
          //console.log('First\nBefore: ' + checkTwice + ' : ' + isFixed);
          checkScrollPosition();
          //console.log('After: ' + checkTwice + ' : ' + isFixed + '\n\n');
        }, 400);
      }
    }
  });
});
